import { DateTime } from 'luxon';

export const dateTimeFormat = 'yyyy-MM-dd HH:mm:ss';

/** Parse and output dates like "Thursday, May 22, 2025" */
export const raTimelineLabelToDate = (label: string): string => {
  const date = DateTime.fromFormat(label, 'DDDD');
  return date.isValid ? date.toFormat('yyyy-MM-dd') : '';
};

/** Parse and output timestamps like 1622548800000 */
export const timestampToDateTime = (timestamp: number): string => {
  const date = DateTime.fromMillis(timestamp);
  return date.isValid ? date.toFormat('yyyy-MM-dd HH:mm:ss') : '';
};

/** Parse and output ISO 8601 strings like "2025-05-22T14:00:00Z" */
export const isoToDateTime = (isoString: string): string => {
  const date = DateTime.fromISO(isoString);
  return date.isValid ? date.toFormat('yyyy-MM-dd HH:mm:ss') : '';
};

/** Parse and output ISO 8601 strings as time only like "14:00:53" */
export const isoToTime = (isoString: string): string => {
  const date = DateTime.fromISO(isoString);
  return date.isValid ? date.toFormat('HH:mm:ss') : '';
};
